import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

import { primaryBlue } from '../../../constants/colors';
import { phoneObjToString } from '../../../utils/helpers';

interface dialogProps {
  open: boolean;
  onClose?: () => void;
  order: any;
}

export default function LoanCloser(props: dialogProps) {
  const { order, open, onClose } = props;

  const handleClickClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClickClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle sx={{ fontSize: 16 }}>
        {'Please report your issue to the Loan Closer on file.'}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id='alert-dialog-description'
          sx={{ color: primaryBlue }}>
          <strong>Loan Closer Information:</strong>
        </DialogContentText>
        <Typography variant='body2'>
          <strong>Name: </strong> {order?.OrderDetails?.LoanCloser?.Name}
        </Typography>
        <Typography variant='body2'>
          <strong>Email: </strong>{' '}
          {order?.OrderDetails?.LoanCloser?.EmailAddress}
        </Typography>
        <Typography variant='body2'>
          <strong>Phone Number: </strong>
          {phoneObjToString(order?.OrderDetails?.LoanCloser?.PhoneNumber)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickClose} autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
